export default "__VITE_ASSET__CdjLSHag__"